export const tableColumnWidths = {
  suites: {
    name: { flex: 1 },
    latestStatus: { flex: 0.5 },
    lastExecuted: { flex: 0.5 },
    executions: { flex: 0.5 },
    latestTests: { flex: 0.5 },
    metrics: { flex: 1 },
    actions: { flex: 0.1 },
  },
  tests: {
    name: { flex: 0.75 },
    suite: { flex: 0.25 },
    latestStatus: { flex: 0.25 },
    lastExecuted: { flex: 0.25 },
    executions: { flex: 0.25 },
    metrics: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  executionRuns: {
    name: { flex: 1 },
    status: { flex: 0.75 },
    suites: { flex: 0.75 },
    tests: { flex: 0.75 },
  },
  suiteExecutions: {
    name: { flex: 1 },
    run: { flex: 0.5 },
    status: { flex: 0.5 },
    tests: { flex: 0.5 },
    details: { flex: 0.75 },
  },
  testExecutions: {
    name: { flex: 1 },
    run: { flex: 0.25 },
    status: { flex: 0.25 },
    details: { flex: 0.5 },
  },
  resultsFiles: {
    file: { flex: 1 },
    status: { flex: 0.75 },
    suites: { flex: 0.75 },
    tests: { flex: 0.75 },
  },
  uploads: {
    id: { flex: 0.75 },
    status: { flex: 0.5 },
    error: { flex: 1 },
  },
} as const;
